import React from "react";
import style from "../../scss/Catalogos.module.scss";
import CatalogoComponent from "./component/CatalogoComponent";
import useCatalogos from "../../hooks/useCatalogos";
import { crearCandidato, editarCandidato, eliminarCandidato } from "../../Api/ApiCandidato";
import { crearLugar, editarLugar, eliminarLugar } from "../../Api/ApiMetodo";
import { TIPOS_CANDIDATO, esOpcionFija, etiquetaTipoCandidato } from "../../constants/tiposCandidato";

const formatoMesas = (numeroMesas) =>
  numeroMesas ? `${numeroMesas} ${numeroMesas === 1 ? "mesa" : "mesas"}` : "Sin mesas";

const CatalogosPages = () => {
  const { candidatos, lugares, recargar } = useCatalogos();

  return (
    <div className={`container ${style.catalogos}`}>
      <h1 className={style.encabezado}>Catálogos electorales</h1>
      <p className={style.descripcion}>
        Administra los candidatos (por corporación: Alcalde o Concejo) y los lugares de votación con su número de
        mesas, que se usan en el registro de electores y en el escrutinio de votos.
      </p>

      <div className="row g-4">
        <div className="col-12 col-lg-6">
          <CatalogoComponent
            titulo="Candidatos"
            etiquetaCampo="Nombre del candidato"
            items={candidatos}
            obtenerValor={(c) => c.nombre}
            opcionesTipo={TIPOS_CANDIDATO}
            obtenerTipo={(c) => c.tipo}
            etiquetaTipo={etiquetaTipoCandidato}
            esFijo={esOpcionFija}
            onCrear={(nombre, tipo) => crearCandidato(nombre, tipo)}
            onEditar={(id, nombre, tipo) => editarCandidato(id, nombre, tipo)}
            onEliminar={eliminarCandidato}
            onCambio={recargar}
          />
        </div>

        <div className="col-12 col-lg-6">
          <CatalogoComponent
            titulo="Lugares de votación"
            etiquetaCampo="Nombre del lugar"
            items={lugares}
            obtenerValor={(l) => l.lugar}
            etiquetaCantidad="Número de mesas del lugar"
            obtenerCantidad={(l) => l.numeroMesas}
            formatoCantidad={formatoMesas}
            onCrear={(lugar, _tipo, numeroMesas) => crearLugar(lugar, numeroMesas)}
            onEditar={(id, lugar, _tipo, numeroMesas) => editarLugar(id, lugar, numeroMesas)}
            onEliminar={eliminarLugar}
            onCambio={recargar}
          />
        </div>
      </div>
    </div>
  );
};

export default CatalogosPages;
